import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=71356da3&lang=pug&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71356da3')) {
      api.createRecord('71356da3', component.options)
    } else {
      api.reload('71356da3', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=71356da3&lang=pug&", function () {
      api.rerender('71356da3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Icon.vue"
export default component.exports